
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5512',
  depVersions: {
  "data-privacy-request-ui": "static-1.5512",
  "data-fetching-client": "static-1.9654",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.7998",
  "hub-http-shared-msw-handlers": "static-1.9911",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11452",
  "I18n": "static-7.1620",
  "jasmine-runner": "static-1.6450",
  "privacy-center-public-service-types": "static-1.4775",
  "quartz": "static-1-hqd-quartz-routing-v2.25",
  "react-dlb": "static-1.78",
  "ui-components-test-utils": "static-1.5589",
  "UIComponents": "static-3.8398",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.85",
  "foundations-assets": "static-1.4848",
  "foundations-components": "static-1.7896",
  "foundations-components-test-utils": "static-1.5379",
  "foundations-theming": "static-1.4403",
  "hub-http": "static-1.6206",
  "quartz-config": "static-1-hqd-quartz-routing-v2.25",
  "quartz-core": "static-1-hqd-quartz-routing-v2.25",
  "quartz-routing": "static-1-hqd-quartz-routing-v2.25",
  "quick-fetch": "static-1.3903",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-rhumb": "static-1.16652",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11135",
  "usage-tracker": "static-1.7328",
  "usage-tracker-anonymous": "static-1.5745",
  "usage-tracker-core": "static-1.7178",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4115",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3387",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1-hqd-quartz-routing-v2.25",
  "quartz-webpack": "static-1-hqd-quartz-routing-v2.25",
  "bend-plugin-quartz-routing": "static-1-hqd-quartz-routing-v2.24",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "HeadJS": "static-2.756",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3109",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "ts-schema": "static-1.4067",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "react-utils": "static-2.5330",
  "StyleGuideUI": "static-3.486",
  "jasmine": "static-4.4311",
  "rpc-client-utils": "static-1.4634",
  "HubStyle": "static-2.11759",
  "ui-addon-draggable": "static-3.4750",
  "cssUtils": "static-1.787",
  "hs-story-utils": "static-1.9411",
  "icons": "static-2.644",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1147",
  "bend-plugin-foundations-components": "static-1.4165",
  "floating-ui": "static-1.55",
  "foundations-theming-specialty": "static-1.2119",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.18",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1836",
  "ui-fonts": "static-1.714",
  "foundations-components-legacy": "static-1.921",
  "bend-plugin-foundations-theming": "static-1.2886",
  "foundations-theming-base": "static-1.3388",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.69",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4639",
  "mobile-manifest-mixins": "static-1.531",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1-hqd-quartz-routing-v2.25",
  "quartz-head": "static-1-hqd-quartz-routing-v2.25",
  "quartz-i18n": "static-1-hqd-quartz-routing-v2.25",
  "quartz-test": "static-1-hqd-quartz-routing-v2.25",
  "quartz-tracking": "static-1-hqd-quartz-routing-v2.25",
  "usage-tracker-container": "static-1.7318",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3186",
  "hubspotter-http-shared-msw-handlers": "static-1.9909",
  "usage-tracker-session-replay": "static-1.5014",
  "bend-plugin-chirp-manifest": "static-1.44",
  "chirp-fetch": "static-1.1871",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.69",
  "sassPrefix": "static-1.155",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5512",
  "data-fetching-client": "/data-fetching-client/static-1.9654",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.7998",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9911",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11452",
  "I18n": "/I18n/static-7.1620",
  "jasmine-runner": "/jasmine-runner/static-1.6450",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4775",
  "quartz": "/quartz/static-1-hqd-quartz-routing-v2.25",
  "react-dlb": "/react-dlb/static-1.78",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5589",
  "UIComponents": "/UIComponents/static-3.8398",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "foundations-assets": "/foundations-assets/static-1.4848",
  "foundations-components": "/foundations-components/static-1.7896",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5379",
  "foundations-theming": "/foundations-theming/static-1.4403",
  "hub-http": "/hub-http/static-1.6206",
  "quartz-config": "/quartz-config/static-1-hqd-quartz-routing-v2.25",
  "quartz-core": "/quartz-core/static-1-hqd-quartz-routing-v2.25",
  "quartz-routing": "/quartz-routing/static-1-hqd-quartz-routing-v2.25",
  "quick-fetch": "/quick-fetch/static-1.3903",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-rhumb": "/react-rhumb/static-1.16652",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11135",
  "usage-tracker": "/usage-tracker/static-1.7328",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5745",
  "usage-tracker-core": "/usage-tracker-core/static-1.7178",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3387",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1-hqd-quartz-routing-v2.25",
  "quartz-webpack": "/quartz-webpack/static-1-hqd-quartz-routing-v2.25",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1-hqd-quartz-routing-v2.24",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "HeadJS": "/HeadJS/static-2.756",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3109",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "ts-schema": "/ts-schema/static-1.4067",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "react-utils": "/react-utils/static-2.5330",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "jasmine": "/jasmine/static-4.4311",
  "rpc-client-utils": "/rpc-client-utils/static-1.4634",
  "HubStyle": "/HubStyle/static-2.11759",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4750",
  "cssUtils": "/cssUtils/static-1.787",
  "hs-story-utils": "/hs-story-utils/static-1.9411",
  "icons": "/icons/static-2.644",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1147",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4165",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2119",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.18",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1836",
  "ui-fonts": "/ui-fonts/static-1.714",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.921",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2886",
  "foundations-theming-base": "/foundations-theming-base/static-1.3388",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.69",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4639",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.531",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1-hqd-quartz-routing-v2.25",
  "quartz-head": "/quartz-head/static-1-hqd-quartz-routing-v2.25",
  "quartz-i18n": "/quartz-i18n/static-1-hqd-quartz-routing-v2.25",
  "quartz-test": "/quartz-test/static-1-hqd-quartz-routing-v2.25",
  "quartz-tracking": "/quartz-tracking/static-1-hqd-quartz-routing-v2.25",
  "usage-tracker-container": "/usage-tracker-container/static-1.7318",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3186",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9909",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5014",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.44",
  "chirp-fetch": "/chirp-fetch/static-1.1871",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.69",
  "sassPrefix": "/sassPrefix/static-1.155",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
